module.exports = __webpack_public_path__ + "static/media/chevron-down-black.60faf62b.svg";